export const OPEN = '[Notification] OPEN NOTIFICATION';
export const DISMISS = '[Notification] CLOSE NOTIFICATION';
export const DISMISSING = '[Notification] CLOSING NOTIFICATION';
export const ADD_NOTIFICATION = '[Notification] ADD NOTIFICATION';
export class Open {
    constructor(payload) {
        this.payload = payload;
        this.type = OPEN;
    }
}
export class Dismiss {
    constructor(payload = null) {
        this.payload = payload;
        this.type = DISMISS;
    }
}
export class Dismissing {
    constructor(payload = null) {
        this.payload = payload;
        this.type = DISMISSING;
    }
}
export class AddNotification {
    constructor(payload) {
        this.payload = payload;
        this.type = ADD_NOTIFICATION;
    }
}
//# sourceMappingURL=notification.actions.js.map